import axios from 'axios';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import * as Yup from 'yup';
import { impersonateData } from '../recoil/atom/impersonate';
import { API_DOMAIN } from '../utils/constants';

const passwordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long'),
});
const businessValidationSchema = Yup.object().shape({
  business: Yup.string().required('Business is required'),
});
export const useImpersonate = () => {
  const navigate = useNavigate();
  const [impersonate, setImpersonate] = useRecoilState(impersonateData);
  const passwordConfirmForm = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema: passwordValidationSchema,
    onSubmit: async (values) => {
      await validatePassword(values);
    },
  });

  const businessSelectForm = useFormik({
    initialValues: {
      business: '',
    },
    validationSchema: businessValidationSchema,
    onSubmit: (values) => {
      const business = businessList.find(
        (item) => item.id.toString()  === values.business.toString()
      );
      setImpersonate({
        business: values.business,
        impersonate: true,
        businessName: business?.businessName || '',
        id: business?.id || '',
        token: sessionStorage.getItem('token'),
        businessDetails: business
      });
      sessionStorage.setItem('business', values.business);
      sessionStorage.setItem('businessName', business?.businessName);
      sessionStorage.setItem('businessDetails', JSON.stringify(business));
      setBusinessSelectionModal(false);
      toast.success('Business selected successfully');
      navigate(0);
    },
  });


  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [businessSelectionModal, setBusinessSelectionModal] = useState(false);

  const [businessList, setBusinessList] = useState([]);

  const validatePassword = async (data) => {
    try {
      const response = await axios.post(
        `${API_DOMAIN}/impersonate/validator`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      if (response.status === 200 && response.data.valid) {
        sessionStorage.setItem('impersonate', 'true');
        sessionStorage.setItem('token', response.data.token);
        setPasswordModalOpen(false);
        setBusinessSelectionModal(true);
        const businessResponse = await axios.get(`${API_DOMAIN}/business`, {
          headers: {
            Authorization: `Bearer ${response.data.token}`,
          },
        });
        setBusinessList(businessResponse.data.business);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || 'An error occurred while impersonating'
      );
    }
  };

  const cancelImpersonation = () => {
    sessionStorage.removeItem('impersonate');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('business');
    setPasswordModalOpen(false);
    setBusinessSelectionModal(false);
    setImpersonate(null);
    toast.success('Impersonation cancelled successfully');
    navigate(0);
  };

  return {
    passwordConfirmForm,
    passwordModalOpen,
    setPasswordModalOpen,
    businessSelectionModal,
    businessSelectForm,
    cancelImpersonation,
    businessList,
    impersonate,
  };
};
